import React from 'react';
import EventCreate from 'components/EventCreate';

import './EventCreateCard.scss';

const EventCreateCard = ({ onCreate, title }) => {
	const cardTitle = title || 'Get Started with Our Quickstart Guide';
	return (
		<div className="EventCreateCard">
			<div className="card-header">
				<div className="card-title">{cardTitle}</div>
				<div className="card-description">
					You'll be able to edit these fields in Event Settings.
				</div>
				<div className="divider" />
			</div>
			<EventCreate onCreate={onCreate} />
		</div>
	);
};

export default EventCreateCard;
